module.exports = __webpack_public_path__ + "img/080.d71ac82c.png";